import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHomeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M17.1185 9.27584L9.6185 0.942507C9.30267 0.59084 8.696 0.59084 8.38017 0.942507L0.880169 9.27584C0.772216 9.3955 0.701356 9.54395 0.676206 9.70314C0.651055 9.86233 0.672698 10.0254 0.738502 10.1725C0.871835 10.4733 1.17017 10.6667 1.49934 10.6667H3.166V16.5C3.166 16.721 3.2538 16.933 3.41008 17.0893C3.56636 17.2455 3.77832 17.3333 3.99934 17.3333H6.49934C6.72035 17.3333 6.93231 17.2455 7.08859 17.0893C7.24487 16.933 7.33267 16.721 7.33267 16.5V13.1667H10.666V16.5C10.666 16.721 10.7538 16.933 10.9101 17.0893C11.0664 17.2455 11.2783 17.3333 11.4993 17.3333H13.9993C14.2203 17.3333 14.4323 17.2455 14.5886 17.0893C14.7449 16.933 14.8327 16.721 14.8327 16.5V10.6667H16.4993C16.6607 10.6674 16.8188 10.6211 16.9544 10.5335C17.0899 10.4458 17.197 10.3207 17.2627 10.1733C17.3283 10.0258 17.3496 9.86246 17.324 9.70311C17.2984 9.54376 17.227 9.39531 17.1185 9.27584Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgHomeIcon);
export { ForwardRef as ReactComponent };
